import { createApp } from 'vue'
import App from './App.vue'
import router from './router'
import './assets/styles/main.css';//Estilos prinicpales

// Crear una nueva instancia de la aplicación Vue
const app = createApp(App)

// Usar Vue Router
app.use(router)

// Montar la aplicación en el elemento con el id 'app'
app.mount('#app')